import Invoices from '@api/routes/myvca-api/careclub-invoices';
import ApiService from '@api/api-service';
//import mock from './mock-pdf-response.json';


var VCA = VCA || {};

VCA.CareclubInvoice = (function ($) {
    var ui = {};
    let page = 0;
    let invoiceCount = 0;
    let invoiceTotal = 0;

    function cacheUI() {
        ui.$invoiceWrapper = $('.js-careclub-invoices');
        ui.$loadMore = $('.js-load-more-invoices');
        ui.$invoiceList = $('.js-invoice-list');
        ui.$invoiceListError = $('.js-invoice-list-error');
        ui.$invoiceListEmpty = $('.js-invoice-list-empty');
        ui.loader = $('.ajax-loader');
    }

    function init() {
        if ($('.js-careclub-invoices').length <= 0) {
            return;
        }
        cacheUI();
        initGetInvoices();
        bindloadMoreClick();
        bindGetInvoiceClick();
    }

    async function initGetInvoices() {

        ui.loader.show();
        var params = {"Page": page};
 
         const { success, data, error }  = await Invoices.post(params);
         if(!success){
            console.log('failed', error);
            $('.js-error-message-text').text(error);
            ui.$invoiceListError.show();
            ui.loader.hide();
            return;
        }
        else if(data.TotalCount == 0) {
            ui.loader.hide();
            ui.$invoiceListEmpty.show();
        }else{
            invoiceTotal = data.TotalCount;
            page = data.CurrentPage + 1;
            createInvoiceList(data.Invoices);
        }

     };


     function createInvoiceList(invoices) {

        let invoiceList = '';

        var count = Object.keys(invoices).length;
        invoiceCount += count;

        $.each(invoices, function (i, item) {

            invoiceList  +=  `
            <div class="myvca-account-list__item" data-invoiceid="${item.Id}">
                <div class="myvca-account-list__item__date">
                ${item.Date}
                </div>
                <div class="myvca-account-list__item__desc">
                ${item.PetName}
                </div>
                <div class="myvca-account-list__item__total">
                ${item.Amount}
                </div>
                <button class="myvca-account-list__item__icon hidden js-inoice-btn" data-invoiceid="${item.Id}">
                    <svg width="100%" height="auto" viewBox="0 0 48 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>PDF Icon</title>
                        <g id="UI-Kit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="UI-Kit---Icons" transform="translate(-1096.000000, -5073.000000)" fill-rule="nonzero">
                                <g id="VCA_Iconography-KIT-RGB_download-pdf" transform="translate(1096.000000, 5073.000000)">
                                    <path d="M47.1395278,18.8481009 L47.1395278,18.8133259 C47.0477443,18.6445807 46.9471439,18.4807826 46.838144,18.3226112 C46.7879134,18.2491972 46.7299549,18.1796471 46.6758604,18.1062331 C46.6217659,18.0328191 46.5483519,17.92463 46.4749379,17.8396244 C46.4015239,17.7546187 46.324246,17.6734769 46.250832,17.5923351 C46.177418,17.5111933 46.1271873,17.4570988 46.0615011,17.3914125 L46.0151344,17.3450458 L32.7619748,2.32222231 C32.6537857,2.19084988 32.5378689,2.06334135 32.4180881,1.93583281 L32.3949047,1.90878555 L32.3949047,1.90878555 L32.2944435,1.80446039 L32.2326212,1.73877417 C32.1592072,1.66922406 32.0819293,1.61126564 32.0085152,1.54557943 C31.9351012,1.47989321 31.9003262,1.44511816 31.8423678,1.39875142 L31.5255284,1.16305383 L31.3632448,1.04713698 C31.2473279,0.969859081 31.1314111,0.900308972 31.0116304,0.830758863 L30.8493468,0.738025385 C30.7257021,0.672339171 30.6020575,0.614380747 30.4629573,0.556422323 L30.2929459,0.479144424 C30.1693013,0.425049895 30.0379288,0.382547051 29.9065564,0.336180312 L29.7210894,0.274357993 C29.5935809,0.235719044 29.4622085,0.204807884 29.3347,0.173896725 C29.2686842,0.153529398 29.2016113,0.136761178 29.1337774,0.123666091 C28.9946772,0.0966188261 28.855577,0.0772993515 28.7164768,0.0579798768 L28.523282,0.0309326123 C28.3184956,0.0309326123 28.1137092,1.06888912e-05 27.9050588,1.06888912e-05 L6.26724721,1.06888912e-05 C4.60747745,-0.00305536159 3.01452154,0.653600545 1.83907475,1.82542389 C0.663627954,2.99724723 0.00205713957,4.58816822 4.80063603e-06,6.24793956 L4.80063603e-06,6.24793956 L4.80063603e-06,57.34795 C-0.00205366607,59.0096924 0.657951603,60.6037985 1.83406897,61.7777405 C3.01018634,62.9516826 4.60551148,63.6087356 6.26724721,63.6035959 L19.0181005,63.6035959 L22.9979123,67.5911355 C23.5476962,68.1362882 24.4341703,68.1362882 24.9839543,67.5911355 L28.963766,63.6035959 L41.7146193,63.6035959 C45.1468616,63.5717949 47.9123068,60.7803397 47.9123068,57.34795 L47.9123068,21.8503473 C47.9123068,20.8004417 47.6461883,19.7676644 47.1395278,18.8481009 Z M34.1259297,8.57014041 L40.3081616,15.6178848 L36.2974386,15.6178848 C35.0990324,15.6136275 34.129786,14.6409257 34.1297936,13.4425119 L34.1259297,8.57014041 Z M44.8211908,57.34795 C44.8211908,59.0914037 43.4078424,60.5047522 41.6643887,60.5047522 L32.0046514,60.5047522 L34.4736802,58.0318595 C35.0184894,57.4870503 34.8330224,57.0388385 34.0641074,57.0388385 L32.8740277,57.0388385 C32.0993965,57.0388385 31.4714339,56.4108758 31.4714339,55.6362446 L31.4714339,47.1936342 C31.4672104,46.4207591 30.841715,45.7952638 30.06884,45.7910403 L17.8318847,45.7910403 C17.0581345,45.7931631 16.4314137,46.419884 16.4292909,47.1936342 L16.4292909,55.6362446 C16.4271681,56.4099948 15.8004472,57.0367157 15.026697,57.0388385 L13.8366174,57.0388385 C13.0638384,57.0388385 12.8822353,57.4870503 13.4270445,58.0318595 L15.8960734,60.5047522 L6.23633605,60.5047522 C4.49652568,60.5004893 3.08898822,59.0877643 3.09112314,57.34795 L3.09112314,41.9348732 L44.8211908,41.9348732 L44.8211908,57.34795 Z M9.25017409,38.6041957 L9.25017409,26.4367906 L13.6897894,26.4367906 C16.313374,26.4367906 17.9787127,27.5341367 17.9787127,30.061124 C17.9787127,32.5881113 16.313374,33.6815936 13.6897894,33.6815936 L11.5916944,33.6815936 L11.5916944,38.5964679 L9.25017409,38.6041957 Z M19.7020099,38.6041957 L19.7020099,26.4367906 L23.7204606,26.4367906 C26.9352212,26.4367906 29.1530969,28.22191 29.1686316,32.5185612 C29.1840081,36.8152124 26.9352212,38.5964679 23.7204606,38.5964679 L19.7020099,38.6041957 Z M37.3020513,31.2937065 L37.3020513,33.225654 L33.2488255,33.225654 L33.2488255,38.5810124 L30.9304886,38.5810124 L30.9304886,26.4367906 L38.6582784,26.4367906 L38.6582784,28.3919214 L33.2488255,28.3919214 L33.2488255,31.2859787 L37.3020513,31.2937065 Z M44.8211908,23.1138409 L3.09112557,23.1138409 L3.09112557,6.24793956 C3.09112557,5.40699407 3.42623408,4.60071515 4.0223209,4.00752899 C4.61840772,3.41434283 5.42631177,3.0831613 6.26724721,3.08723566 L28.2914483,3.08723566 L28.5000986,3.11818466 L28.6160155,3.14909582 C28.6786081,3.15492471 28.7398928,3.17057186 28.7976186,3.19546256 L28.9212632,3.23796541 L29.0835468,3.29978773 L29.2033275,3.35774615 L29.3540194,3.473663 L29.4738002,3.54321311 L29.6129004,3.62821879 L29.7249533,3.70936059 L29.8563258,3.80595796 L29.9606509,3.89869144 L30.06884,3.99915271 L30.3740877,4.34690325 C30.800546,4.90034696 31.0303258,5.58016903 31.0270859,6.27885072 L31.0270859,13.4231925 C31.0219469,14.8239663 31.5750689,16.1690744 32.564121,17.1610269 C33.5531731,18.1529795 34.8966557,18.7100379 36.2974386,18.7090007 L41.6643887,18.7090007 C42.4717377,18.7098439 43.2478464,19.0211174 43.8320337,19.5783771 C43.8745366,19.617016 43.9170394,19.6595189 43.9556784,19.7020217 C43.9943173,19.7445246 44.0213646,19.7677079 44.0522758,19.8063469 L44.1604648,19.9377193 L44.2454705,20.0536362 L44.338204,20.1966003 L44.411618,20.3202449 L44.4927598,20.4748007 C44.5159431,20.5173035 44.5352626,20.5598064 44.5545821,20.6023092 C44.5739016,20.6448121 44.6009488,20.7143622 44.6202683,20.7723206 C44.6395878,20.830279 44.6550434,20.8573263 44.666635,20.8998291 C44.6782267,20.942332 44.705274,21.0234738 44.7207296,21.0852961 C44.7274001,21.1285984 44.7377411,21.1712549 44.7516407,21.2128046 C44.7516407,21.2553075 44.7748241,21.3557687 44.7864158,21.4253189 C44.7925426,21.4611217 44.7925426,21.4977051 44.7864158,21.5335079 C44.7986263,21.6451546 44.8050746,21.7573563 44.8057353,21.8696668 L44.8211908,23.1138409 Z" id="Shape" fill="#174A94"></path>
                                    <path d="M15.6565119,30.0688518 C15.6565119,28.9908251 15.1696611,28.333963 13.4231806,28.333963 L11.5916944,28.333963 L11.5916944,31.8114684 L13.4425001,31.8114684 C15.1542056,31.7998768 15.6565119,31.1430146 15.6565119,30.0688518 Z" id="Path" fill="#174A94"></path>
                                    <path d="M23.5697687,28.3996492 L22.0242107,28.3996492 L22.0242107,36.6529288 L23.5697687,36.6529288 C26.2281284,36.6529288 26.8502155,34.697798 26.8502155,32.526289 C26.8502155,30.35478 26.2281284,28.3996492 23.5697687,28.3996492 Z" id="Path" fill="#174A94"></path>
                                    <path d="M15.8960734,60.5047522 L13.4270445,58.0318595 C12.8822353,57.4870503 13.0638384,57.0388385 13.8366174,57.0388385 L15.026697,57.0388385 C15.8004472,57.0367157 16.4271681,56.4099948 16.4292909,55.6362446 L16.4292909,47.1936342 C16.4314137,46.419884 17.0581345,45.7931631 17.8318847,45.7910403 L30.06884,45.7910403 C30.841715,45.7952638 31.4672104,46.4207591 31.4714339,47.1936342 L31.4714339,55.6439724 C31.4714339,56.4186036 32.0993965,57.0465662 32.8740277,57.0465662 L34.0641074,57.0465662 C34.8368863,57.0465662 35.0184894,57.4947781 34.4736802,58.0395872 L32.0046514,60.51248 L28.9444466,63.6035959 L24.9646348,67.5911355 C24.4148508,68.1362882 23.5283768,68.1362882 22.9785928,67.5911355 L19.0181005,63.6035959 L15.8960734,60.5047522 Z" id="Path" fill="#3CC4E5"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </button>
            </div>
            `;
        });
        ui.$invoiceList.append(invoiceList);
        if(invoiceTotal > invoiceCount){
            ui.$loadMore.show();
        }else{ui.$loadMore.hide();}


        ui.loader.hide();

     }

    function bindloadMoreClick() {
        ui.$invoiceWrapper.on('click', '.js-load-more-invoices', function (e) {
            e.preventDefault();
            ui.loader.show();
            initGetInvoices();
        });
    }

    async function getInvoice(invoiceid) {
        const url = 'myvca-api/invoice/getinvoice/' + invoiceid;
        let api = new ApiService(url);
        const { data, success, error } = await api.post();

        if (!success || (error !== null && error !== '')) {
            alert(`Sorry, this document is not available. ${error}`);
            console.log(`Status: ${error}`);
        } else { 
            //let response = data.Result;
            let response = data.Result;
            var pdfWindow = window.open("");
            pdfWindow.document.write("<html<head><title></title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
            pdfWindow.document.write('<html><body><object data="' + response + '" type="application/pdf" width="100%" height="100%"></object>');
        }
    }

    function bindGetInvoiceClick() {
        ui.$invoiceWrapper.on('click', '.js-inoice-btn', function (e) {
            e.preventDefault();
            let invoiceid = $(this).data('invoiceid');
            getInvoice(invoiceid);
        });
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.CareclubInvoice.init();
});


